export default {
    namespaced:  true,
    state: {
        notificationsPopupId: null,
        numberOfNotifications: 0,
    },
    getters: {
        notificationsPopupId: state => {
            return state.notificationsPopupId;
        },
        numberOfNotifications: state => {
            return state.numberOfNotifications;
        }
    },
    mutations: {
        openNotificationsPopup: (state, notificationId) => {
            state.notificationsPopupId = notificationId;
            $("#notifications-popup").modal("show");
        },
        closeNotificationsPopup: (state) => {
            $("#notifications-popup").modal("hide");
            state.notificationsPopupId = null;
        },
        setNumberOfNotifications: (state, numberOfNotifications) => {
            state.numberOfNotifications = numberOfNotifications;
        }
    }
}